import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import SmartComponent from '../../../ComponentBlueprint/SmartComponent'
import SmartComponentLoader from '../../../ComponentBlueprint/SmartComponentLoader'
import { getItems } from '../fieldResolver'
import { getNested } from '../utils'

class SmartComponentErrorBoundary extends React.Component {
  state = { hasError: false }

  static getDerivedStateFromError () {
    return { hasError: true }
  }

  render () {
    if (this.state.hasError) {
      return (
        <div className='p-md font-size-sm' style={{ color: 'var(--color-warning-500)' }}>
          Failed to render component &quot;{this.props.blueprintCode}&quot;
        </div>
      )
    }
    return this.props.children
  }
}

SmartComponentErrorBoundary.propTypes = {
  blueprintCode: PropTypes.string,
  children: PropTypes.node
}

function SmartComponentLayout ({ data, displayConfig }) {
  const {
    blueprintCode,
    presentationKey,
    styleVariant,
    styleVariantParams,
    idField,
    integration,
    containerStyle
  } = displayConfig ?? {}

  const configOverrides = useMemo(() => {
    if (!idField) return undefined
    const items = getItems(data, displayConfig)
    const filterIds = items
      .map(row => getNested(row, idField))
      .filter(value => value !== undefined && value !== null && value !== '')
    return { filterIds }
  }, [data, displayConfig, idField])

  if (!blueprintCode || !presentationKey) return null

  const content = (
    <SmartComponentErrorBoundary blueprintCode={blueprintCode}>
      <SmartComponentLoader blueprintCode={blueprintCode} integration={integration}>
        <SmartComponent
          blueprintCode={blueprintCode}
          presentationKey={presentationKey}
          styleVariant={styleVariant}
          styleVariantParams={styleVariantParams}
          configOverrides={configOverrides}
        />
      </SmartComponentLoader>
    </SmartComponentErrorBoundary>
  )

  if (containerStyle) {
    return <div style={containerStyle}>{content}</div>
  }

  return content
}

SmartComponentLayout.propTypes = {
  data: PropTypes.object,
  displayConfig: PropTypes.object
}

export default SmartComponentLayout
